import { InfoBanner } from '@ui';
import { OrganType } from '@/api/apis/case';
import { TrialProgram } from '@/api/apis/facilities/trial-programs';
import { hasActiveTrialProgram } from '@/utils/helpers';

type ReallocationTxTrialWarningBannerProps = {
  organType: OrganType;
  txCenterTrialPrograms?: TrialProgram[];
  reAllocationTrialProgram?: TrialProgram;
  reAllocationCase?: boolean;
};

export const ReallocationTxTrialWarningBanner = ({
  organType,
  reAllocationTrialProgram,
  txCenterTrialPrograms,
  reAllocationCase,
}: ReallocationTxTrialWarningBannerProps) => {
  const hasTxTrialProgram = hasActiveTrialProgram(organType, txCenterTrialPrograms);

  if (!reAllocationCase || (!reAllocationTrialProgram && !hasTxTrialProgram)) {
    return null;
  }

  return (
    !reAllocationTrialProgram &&
    hasTxTrialProgram && (
      <InfoBanner iconType="warning">
        Commercial case is re-allocated to TX Center participating in a trial program.
      </InfoBanner>
    )
  );
};
